import Page from "../../features/Recursos/Page";


export default function Recursos(){
    return <Page/>
}